import { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import RelatedLinks from '../RelatedLinks';
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import { SERVER_URL } from '../ConstantsEN';
import { DueDate_EndPoint } from '../ConstantsEN';
import { CalculatorsType } from '../ConstantsEN';
import { CycleLengthComponent } from './Component';
import { DueDateTable } from './Tables';
import SharedHelmet from "../Helmet";
const TITLE = 'Pregnancy Due Date Calculator';
const DESCRIPTION = 'Due date calculator estimates a woman\'s expected delivery date based on her last menstrual period (LMP).';
const KEYWORDS = 'due date, due date calculator, expected due date';
const OG_URL = 'https://do-calculate.com/calculator/en/pregnancy-due-date/';
const apiEndpoint = `${SERVER_URL}/${DueDate_EndPoint}`;
function DueDate() {
    const [firstDayOfLastPeriod, setFirstDate] = useState();
    const [cycleLength, setCyrcleLength] = useState(28);
    const [result, setRestul] = useState(null);
    const [statusCode, setStatusCode] = useState(null);
    const handleDateChange = (event) => {
        setFirstDate(event.target.value)
    };
    const calculateDueDate = async () => {
        try {
            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ firstDayOfLastPeriod, cycleLength }),
            });
            const data = await response.json();
            setStatusCode(response.status);
            if (response.ok) {
                setRestul(data.result);
            } else {
                setRestul(null);
            }
        } catch (error) {
            console.error(error);
        }
    };
    return (
        <div>
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <div className="bg-success text-white text-center" style={{ height: '40px', }}><b>Pregnancy Due Date Calculator</b></div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                Due date calculator estimates a woman's expected delivery date based on her last menstrual period (LMP).
                                <br />
                                <hr />
                            </div>
                            <br />
                        </div>
                        <MobileUnderCalAds />
                        <div className="row">
                            <div className='col-12 col-md-5 calculatorStyle'>
                                <div className='p-3 mb-2 bg-success text-white'>
                                    Due Date Calculator
                                </div>
                                <hr />
                                <br />
                                <div className=" form-group d-flex align-items-center">
                                    <b>  <label className="form-label ms-2" >
                                        <strong>First Day</strong> of Last Menstrual Period
                                    </label>
                                    </b>
                                    <br />
                                    <input
                                        type="date"
                                        id="weightNumber"
                                        value={firstDayOfLastPeriod}
                                        onChange={handleDateChange}
                                        className="form-control ml-2"
                                        style={{ width: '145px' }}
                                        placeholder="175"
                                    />
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>  <label htmlFor="CycleLength" className="form-label ms-2">
                                        Average Time Between Periods
                                    </label>
                                    </b>
                                    <CycleLengthComponent handleDateChange={setCyrcleLength} />
                                    <div className="input-group-append">
                                        <span className="input-group-text ">days</span>
                                    </div>
                                </div>
                                <br />
                                <hr />
                                <div>
                                    <button className="btn btn-success" style={{ fontSize: '20px' }} onClick={calculateDueDate}>Calculate</button>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-7">
                                <br />
                                {statusCode === 400 && <div className="alert alert-warning"><b><u>Error:</u></b> Please enter all fields correctly.</div>}
                                {result && (
                                    <div>
                                        <h4><div className="p-3 mb-2 bg-success text-white">Results: </div></h4>
                                        <hr />
                                        <DueDateTable result={result}></DueDateTable>
                                    </div>
                                )}
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col" >
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.womenCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: 'auto' }} >
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">Description of Due Date Calculator:</div>
                            <div className="info-section-body">
                                <u><b>Estimated Due Date</b></u>
                                <br />
                                The estimated due date, also known as the estimated date of delivery (EDD), is an estimate of a pregnant woman's expected delivery date. While the estimated due date is typically given as a single date, it's useful to consider a range of due dates, as only 4% of births occur on the estimated due date.
                                <br/>                                Estimated due dates can be determined using several different methods, including the last menstrual period (LMP), ultrasound, date of conception, and in vitro fertilization (IVF) embryo transfer date.
                                <br/>                                <u><b>Last Menstrual Period (LMP)</b></u>
                                <br />
                                The default assumption for this calculator is based on a woman's last menstrual period (LMP), assuming that childbirth on average occurs at a gestational age (pregnancy age calculated from the LMP) of 280 days or 40 weeks. Although there is some debate about when pregnancy technically begins, either at fertilization of the egg (conception) or implantation of the egg in the uterus (implantation), gestational age remains unchanged based on different definitions of pregnancy because it relies on the last menstrual period. In terms of gestational age, pregnancies usually last between 37 and 42 weeks, with 40 weeks being a common estimate for calculations. Therefore, pregnancy is counted in weeks, starting from the LMP.
                                <br/>                                <u><b>Estimated Due Date as a Milestone</b></u>
                                <br />
                                Generally, the timing of a baby's birth between 37 and 42 weeks is not a cause for concern. Babies born between weeks 37-39, 39-41, and 41-42 are considered preterm, full-term, and post-term, respectively. In normal circumstances, babies born during any of these periods can be healthy, although babies born full-term generally have better outcomes. Babies born before 37 weeks are considered premature, while babies born after 42 weeks are considered overdue. These periods serve as milestones for doctors to determine whether any intervention is needed. For example, if a woman goes into very early labor at 33 weeks, doctors may try to delay delivery to avoid premature birth, which can lead to a range of health problems due to underdeveloped organs. Conversely, if a woman hasn't gone into labor by 42 weeks, doctors may induce labor. One potential complication of allowing a pregnancy to continue past 42 weeks is that the placenta, which is responsible for providing nutrition and oxygen to the baby, can stop functioning properly while the baby continues to grow, requiring more nutrients and oxygen, ultimately resulting in
                                <br/>                                <hr />
                                <b>Last Reviewed Date:</b> 28/02/2026
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default DueDate;
